import React, { useEffect, useState } from 'react';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonModal, IonTextarea, IonTitle, IonToolbar } from '@ionic/react';
import { alertCircle, arrowBack, star, starOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { avaliarProjeto, requestService } from '../../../../../Utils/Services';
import './PedidoAvaliacao.css';

let proximoCampoAvaliacao = 0;

const PedidoAvaliacao: React.FC<{ pedido: any; aberta: boolean; onClose: () => void; onSuccess: (estrelas: number, comentario: string) => void }> = ({ pedido, aberta, onClose, onSuccess }) => {
  const history = useHistory();
  const [campoId] = useState(() => `pedido-avaliacao-${++proximoCampoAvaliacao}`);
  const projetoId = pedido.pk.replaceAll(/#/g, '%23');
  const [valorEstrela, setValorEstrela] = useState(pedido.avaliacaoCliente || 0);
  const [comentario, setComentario] = useState(pedido.comentarioCliente || '');
  const [alertaPreenchimento, setAlertaPreenchimento] = useState(false);
  const [textoEstrela, setTextoEstrela] = useState('Selecione');
  const abrirAvaliar = aberta;
  const setAbrirAvaliar = (aberto: boolean) => { if (!aberto) onClose(); };
  useEffect(() => {
    if (aberta) {
      setValorEstrela(pedido.avaliacaoCliente || 0);
      setComentario(pedido.comentarioCliente || '');
      setAlertaPreenchimento(false);
      setTextoEstrela(['Selecione uma nota', 'Muito ruim', 'Ruim', 'Normal', 'Bom', 'Excelente'][pedido.avaliacaoCliente || 0]);
    }
  }, [aberta, pedido]);
  function ajustaTextoEstrela(value: any) {
    if (value === 1) setTextoEstrela("Muito ruim");
    if (value === 2) setTextoEstrela("Ruim");
    if (value === 3) setTextoEstrela("Normal");
    if (value === 4) setTextoEstrela("Bom");
    if (value === 5) setTextoEstrela("Excelente");
  }

  function avaliar() {
    const atualizar = async () => {
      requestService(avaliarProjeto.url, {
        method: avaliarProjeto.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        body: JSON.stringify({
          "id": projetoId,
          "avaliacao": valorEstrela + "",
          "comentario": comentario ? comentario + "" : "Sem comentário."
        }),
        credentials: 'include'
      },
        history,
        (response: any) => {
          if (response.message) {
            console.log(response);
            setAbrirAvaliar(false);
            onSuccess(valorEstrela, comentario);
          }
        },
        (error: any) => {
          console.log(error);
        });
    }

    if (valorEstrela !== 0) {
      setAlertaPreenchimento(false);
      atualizar();
    }
    else {
      setAlertaPreenchimento(true);
    }

  }



  return (
    <IonModal isOpen={abrirAvaliar} className="mini-modal pedido-avaliacao-modal" onDidDismiss={() => setAbrirAvaliar(false)}>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton className="pedido-fluxo-back-button" aria-label="Voltar" fill="clear" onClick={() => setAbrirAvaliar(false)}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
          </IonButtons>
          <IonTitle><span className="modal-title-text">Avaliar pedido</span></IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="pedido-avaliacao-content">
        <div className="pedido-avaliacao-identificacao"><strong>{pedido.empresaNome || 'Pedido'}</strong><span>{pedido.nomeProjeto}</span></div>
        <fieldset className="pedido-avaliacao-nota" aria-describedby={alertaPreenchimento ? `${campoId}-erro` : undefined}>
          <legend>Como foi seu pedido?</legend>
          <p>Escolha de 1 a 5 estrelas para avaliar</p>
          <div className="pedido-avaliacao-estrelas">
            {[1, 2, 3, 4, 5].map(nota => <label key={nota} className="pedido-avaliacao-estrela">
              <input type="radio" name={`${campoId}-nota`} value={nota} checked={valorEstrela === nota} aria-label={`${nota} ${nota === 1 ? 'estrela' : 'estrelas'}`} onChange={() => { setAlertaPreenchimento(false); setValorEstrela(nota); ajustaTextoEstrela(nota); setAbrirAvaliar(true); }} />
              <IonIcon icon={nota <= valorEstrela ? star : starOutline} aria-hidden="true" />
            </label>)}
          </div>
          <span className="pedido-avaliacao-nota-texto" aria-live="polite">{valorEstrela ? textoEstrela : 'Selecione uma nota'}</span>
          {alertaPreenchimento && <div id={`${campoId}-erro`} className="pedido-avaliacao-erro" role="alert"><IonIcon icon={alertCircle} aria-hidden="true" /><span>Campo obrigatório</span></div>}
        </fieldset>
        <div className="pedido-avaliacao-campo">
          <label htmlFor={`${campoId}-comentario`}>Comentário <span>(opcional)</span></label>
          <IonTextarea id={`${campoId}-comentario`} aria-label="Comentário" rows={3} value={comentario}
            placeholder="Conte-nos o que aconteceu (opcional)"
            onIonChange={e => setComentario(e.detail.value!)} />
        </div>
      </IonContent>
      <IonFooter className="ion-no-border pedido-avaliacao-footer">
        <IonToolbar><IonButton className="pedido-avaliacao-enviar" onClick={() => { avaliar() }}>Avaliar</IonButton></IonToolbar>
      </IonFooter>
    </IonModal>
  );
};
export default PedidoAvaliacao;
